export const lang: any = {
  get: (string: string, parameters: string[]) => {
    switch (string) {
      case 'MAX_ORDER_QUANTITY_REACHED_SUMMARY':
        return `The maximum order quantity reached.`;
      case 'MAX_ORDER_QUANTITY_REACHED_DETAILS':
        return `You cannot order more than ${parameters && parameters.length > 0 ? parameters[0] : ''
          } units of this product.`;
      case 'YOU_CAN_ADD_MORE':
        return `You can add ${parameters[0]} more`;
      case 'QUANTITY_EXCEEDS_STOCK':
        return `Quantity exceeds available stock. Only ${parameters && parameters.length > 0 ? parameters[0] : '0'} available.`;
      case 'ORDER_BEFORE_CUTOFF_AND_KITCHEN_PREPARES':
        return `Order before ${parameters && parameters.length > 0 ? parameters[0] : ''} to get earlier delivery`;
      case 'ADDON_SHOW_MORE_COUNT':
        return `Show ${parameters?.[0] ?? ''} more`;
      case 'ADDON_SHOW_MORE_GROUPS_ONE':
        return `Show ${parameters?.[0] ?? ''} more group`;
      case 'ADDON_SHOW_MORE_GROUPS_MANY':
        return `Show ${parameters?.[0] ?? ''} more groups`;
      case 'FIRST_AVAILABLE':
        return `First available ${parameters && parameters.length > 0 ? parameters[0] : ''}`;
      default:
        return '';
    }
  },
  CORPORATE_CATERING: 'Corporate catering',
  GO_TO_CHECKOUT: 'Go to checkout',
  FIRST_AVAILABLE: 'First available',
  SELECT_PICKUP_DATE: 'Select pickup date',
  MAX_ORDER_QUANTITY_REACHED_SUMMARY: 'The maximum order quantity reached.',
  MAX_ORDER_QUANTITY_REACHED_DETAILS: 'You cannot order more than the maximum allowed units of this product.',
  ADD_TO_CART: 'Add to cart',
  MORE_INFO: 'More info',
  COMPLETE_YOUR_ORDER: 'Complete Your Order',
  CHECKOUT_SUBTITLE: 'Follow the steps below to finalize your purchase',
  PICKUP_INSTRUCTIONS_LABEL: 'Pickup instructions',
  DELIVERY: 'Delivery',
  INFORMATION: 'Information',
  SUMMARY: 'Summary',
  PAYMENT: 'Payment',
  DELIVERY_DETAILS: 'Delivery Details',
  CHOOSE_DELIVERY_METHOD_AND_TIME: 'Choose delivery method, date and time',
  SELECTED_DELIVERY_METHOD: 'Selected Delivery Method',
  PICKUP: 'Pickup',
  COLLECT_FROM_LOCATION: 'Collect from our location',
  DELIVER_TO_ADDRESS: 'Deliver to your location',
  DELIVERY_LOCATION: 'Delivery Location',
  DELIVERY_LOCATION_PROMPT: 'Where should we deliver your order?',
  SELECT_DELIVERY_LOCATION: 'Select Delivery Location',
  CONNECTED_COMPANY: 'Connected Company',
  LOCATIONS_NAME: 'Location Name',
  STREET_ADDRESS: 'Street Address',
  CITY: 'City',
  POSTAL_CODE: 'Postal Code',
  FLOOR: 'Floor',
  DELIVERY_ROOM: 'Delivery Room',
  DOOR_CODE: 'Door Code',
  DATE_AND_TIME: 'Date & Time',
  PICKUP_DATE_AND_TIME: 'Pickup date and time',
  DELIVERY_DATE_AND_TIME: 'Delivery date and time',
  SELECT_DATE: 'Select Date',
  SELECT_TIME: 'Select Time',
  ADDITIONAL_INSTRUCTIONS: 'Additional Instructions',
  COMMENT_TO_RESTAURANT: 'Comment to Restaurant',
  COMMENT_TO_RESTAURANT_PLACEHOLDER:
    'Do you have anything you would like to inform us about?',
  CONTINUE_TO_INFORMATION: 'Continue to Your Information',
  CONTINUE: 'Continue',
  CONTINUE_CHECKOUT: 'Continue checkout',
  YOUR_INFORMATION: 'Your Information',
  CONTACT_BILLING_DETAILS: 'Contact and billing details',
  CONTACT_INFO: 'Contact information',
  CONTACT_INFO_DESCRIPTION:
    'We will use this information to contact you about your order.',
  FIRST_NAME: 'First Name',
  FIRST_NAME_REQUIRED: 'First name is required.',
  LAST_NAME: 'Last Name',
  EMAIL_ADDRESS: 'Email Address',
  PHONE_NUMBER: 'Phone Number',
  ADDITIONAL_INFORMATION: 'Additional Information',
  BACK: 'Back',
  PREVIOUS: 'Previous',
  CONTINUE_TO_SUMMARY: 'Continue to Summary',
  ORDER_SUMMARY: 'Order Summary',
  ORDER_SUMMARY_SUBTOTAL: 'Review your order details',
  YOUR_ITEMS: 'Your Items',
  YOUR_ORDER: 'Your order',
  CLOSE: 'Close',
  TOTAL_AMOUNT: 'Total Amount',
  DELIVERY_INFORMATION: 'Delivery Information',
  DELIVERY_METHOD: 'Delivery method',
  NAME: 'Name',
  CREATED: 'Created',
  EMAIL: 'Email',
  USER_ID: 'User ID',
  PHONE: 'Phone',
  ADDRESS: 'Address',
  RESTAURANT_INFO: 'Restaurant Information',
  COMPANY_NAME: 'Company Name',
  PROCEED_TO_PAYMENT: 'Proceed to Payment',
  PAYMENT_METHOD: 'Payment Method',
  SELECT_PAYMENT_METHOD: 'Select Payment Method',
  PAYMENT_METHOD_DESCRIPTION: 'Choose your preferred payment option',
  CREDIT_CARD: 'Credit Card',
  CREDIT_CARD_DESCRIPTION: 'Pay securely with card',
  INVOICE: 'Invoice',
  INVOICE_DESCRIPTION: 'Pay later via invoice',
  CASH: 'Cash',
  CASH_DESCRIPTION: 'Pay on delivery/pickup',
  CONFIRM_ORDER: 'Confirm payment',
  ORDER_PLACED: 'Order Placed!',
  SUCCESS_TEXT_1:
    "Your order has been placed successfully. We'll send you a confirmation email shortly.",
  SUCCESS_TEXT_2:
    'After completing the payment checkout session, you will receive an order confirmation email. Check your email for future order updates.',
  PAYMENT_REQUIRED: 'Payment Required',
  INCOMPLETE_ORDER: 'Incomplete Order',
  KEEP_SHOPPING: 'Keep shopping',
  CANCEL_CHECKOUT_PROMPT: 'Are you sure that you want to cancel checkout?',
  CONFIRMATION: 'Confirmation',
  CANCEL: 'Cancel',
  YES: 'Yes',
  TOTAL_PRICE_IS_0: 'Total Price is 0',
  PLEASE_ADD_ITEMS_TO_CART: 'Please add items to the cart',
  ITEM: 'Item',
  ITEMS: 'Items',
  EMPTY_CART: 'Your cart is empty',
  ADD_SOME_ITEMS: 'Add some items to get started!',
  SHOPPING_CART: 'Shopping Cart',
  CLEAR_CART: 'Clear Cart',
  CLEAR_CART_WARNING: 'Are you sure you want to clear the cart?',
  CLEAR_CART_YES: 'Clear cart',
  CLEAR_CART_NO: 'Dont clear cart',
  CART_ITEMS_NOT_AVAILABLE_FOR_SELECTED_DATE: 'Some items in your cart are not available for the selected delivery date. You can remove them yourself or continue.',
  NOT_AVAILABLE_FOR_DATE: 'Not available on selected date',
  CLEAR: 'Clear',
  SUBTOTAL: 'Subtotal',
  TOTAL_ITEMS: 'Total Items',
  TOTAL: 'Total',
  VAT: 'VAT',
  CHECKOUT: 'Checkout',
  CONTACT: 'Contact',
  LOCATION: 'Location',
  Mobile_Pay_DESCRIPTION: 'Pay securely with mobile pay',
  Mobile_Pay: 'MobilePay',
  CONTINUE_SHOPPING: 'Continue Shopping',
  QUANTITY: 'Quantity',
  LANGUAGE: 'Language',
  SELECT_LANGUAGE: 'Select Language',
  CURRENT: 'Current',
  NO_LANGUAGES_FOUND: 'No languages found',
  TRY_DIFFERENT_SEARCH: 'Try a different search term',
  CHOOSE_A_DATE: 'Choose a date',
  CHOOSE_A_TIME: 'Choose a time',
  SELECT_PICKUP_TIME: 'Select pickup time',
  COMPANY_NAME_OPTIONAL: 'Company name (optional)',
  LOCATION_NAME_OPTIONAL: 'Location name (optional)',
  ENTER_STREET_ADDRESS: 'Enter street address',
  ENTER_CITY: 'Enter city',
  ENTER_POSTAL_CODE: 'Enter postal code',
  FLOOR_NUMBER_OPTIONAL: 'Floor number (optional)',
  ROOM_NUMBER_OPTIONAL: 'Room number (optional)',
  ACCESS_CODE_OPTIONAL: 'Access code (optional)',
  ENTER_FIRST_NAME: 'Enter your first name',
  ENTER_LAST_NAME: 'Enter your last name',
  ENTER_EMAIL: 'Enter your email address',
  ENTER_ADDRESS: 'Enter your address',
  EMAIL_REQUIRED: 'Email address is required.',
  EMAIL_INVALID: 'Please enter a valid email address.',
  SUCCESS: 'Success',
  ERROR: 'Error',
  SAVING: 'Saving…',
  SET_PASSWORD_TITLE: 'Set your password',
  SET_PASSWORD_FOR_ACCOUNT: 'For account:',
  SET_PASSWORD_SUBTITLE: 'Set a new password for your account.',
  NEW_PASSWORD: 'New password',
  CONFIRM_NEW_PASSWORD: 'Confirm new password',
  SAVE_PASSWORD: 'Save password',
  PROCESSING_LINK: 'Processing link…',
  RESET_LINK_INVALID: 'The password reset link is invalid or has expired.',
  FILL_BOTH_PASSWORD_FIELDS: 'Please fill in both password fields.',
  PASSWORDS_DO_NOT_MATCH: 'Passwords do not match.',
  PASSWORD_TOO_SHORT: 'Password must be at least 6 characters long.',
  PASSWORD_RESET_SUCCESS: 'Password has been reset successfully.',
  PASSWORD_RESET_FAILED: 'Failed to reset password. Please try again.',
  LOGIN_SUCCESS: 'You are now logged in.',
  DELIVERY_OPTIONS_UNLOCKED: 'Delivery options are now available.',
  LOGIN_INVALID_CREDENTIALS: 'Invalid email or password.',
  AUTH_EMAIL_MISSING_AT: "Please include an '@' in your email address.",
  LOGIN_FAILED: 'Login failed. Please try again.',
  ACCOUNT_CREATED_SUCCESS: 'Account created successfully.',
  ACCOUNT_CREATED_FAILED: 'Failed to create account.',
  ACCOUNT_ALREADY_EXISTS_ON_THIS_MAIL: 'Account already exists on this mail.',
  OKAY: 'Okay',
  ADD_TO_CART_HEADER: 'Add to cart',
  PER_UNIT: 'per unit',
  QUANTITY_LABEL: 'Quantity (min. {{min}})',
  MIN_ORDER_QUANTITY: 'Minimum order quantity',
  MAX_ORDER_QUANTITY: 'Maximum order quantity',
  UNITS: 'units',
  PICKUP_TIME: 'Pickup Time',
  DELIVERY_TIME: 'Delivery Time',
  DELIVERY_DATE: 'Delivery Date',
  PICKUP_DATE: 'Pickup Date',
  ORDER_TYPE: 'Order type',
  HOME_DATE_SELECTION_UNAVAILABLE_TITLE: 'No serving methods available',
  HOME_DATE_SELECTION_UNAVAILABLE_DESCRIPTION: 'This restaurant is currently not accepting pickup or delivery orders.',
  HOME_DATE_SELECTION_UNAVAILABLE_NOTE: 'Not accepting orders right now',
  SELECT_DELIVERY_DATE: 'Select delivery date',
  SELECT_DELIVERY_AND_DATE: 'Delivery & date',
  SELECT_ORDER_DATE: 'Delivery method and date',
  SELECT_WEEKDAY: 'Choose between pickup or corporate delivery and select your preferred date',
  CONTINUE_WITHOUT_DATE: 'Continue without date',
  JUST_BROWSING: 'Just browsing',
  CONFIRM: 'Confirm',
  PRICE: 'Price',
  PRODUCT_DESCRIPTION: 'Product Description',
  READ_MORE: 'Read More',
  READ_LESS: 'Read Less',
  SERVINGS_PER_PRODUCT: 'Servings per product',
  RETURN_TO_HOME: 'Return to Home',
  ORDER_FAILED: 'Order Failed',
  MAXIMUM_ORDER_QUANTITY: 'Maximum',
  MINIMUM_ORDER_QUANTITY: 'Minimum',
  LOCATION_FOOTER: 'Address',
  INFO_FOOTER: 'More information',
  HOSTED_BY_PUBQ: 'Hosted by PubQ AB',
  TERMS_OF_SERVICE: 'Terms of service',
  NO_PRODUCTS_AVAILABLE: 'No products available',
  CHECK_BACK_SOON_CATEGORY: 'Check back soon for new items in this category',
  NO_CATEGORIES_AVAILABLE: 'No categories available',
  CHECK_BACK_LATER: 'Check back later for updates!',
  NO_MENU_AVAILABLE: 'No menu available',
  MENU_UPDATING_MESSAGE:
    "We're currently updating our menu. Please check back soon for our delicious offerings!",
  REFRESH_PAGE: 'Refresh Page',
  CONTACT_US: 'Contact Us',
  READ_TERMS: 'I have read the Terms of Use',
  ACCEPT_PURCHASE_TERMS_PREFIX: 'By completing this purchase, you accept our ',
  TERMS_AND_CONDITIONS: 'Terms and Conditions',
  ACCEPT_PURCHASE_TERMS_AND: ' and ',
  PRIVACY_POLICY: 'Privacy Policy',
  NO_PRODUCTS_IN_CATEGORY: 'No products in this category',
  NO_PRODUCTS_MATCH_FILTERS: 'No products match your selected filters.',
  PRODUCTS_COMING_SOON: 'Products coming soon!',
  MOVE_TO_CAMPAIGN_MENU: 'Move to Campaign',
  CLOSE_CART: 'Close Cart',
  TIME_SLOT_NOT_SELECTED: 'Time slot not selected',
  SEE_MORE: 'See More',
  SOON_BACK_IN_STOCK: 'Soon back in stock',
  FEW_LEFT_IN_STOCK: 'Few left in stock',
  OUT_OF_STOCK: 'Out of Stock',
  QUANTITY_EXCEEDS_STOCK: 'Quantity exceeds available stock. Only {{0}} available.',
  INACTIVE: 'Inactive',
  CURRENTLY_UNAVAILABLE: 'Currently unavailable',
  PREPARATION_DAYS_REQUIRED: 'Preparation days required',
  DAYS: 'Days',
  AVAILABLE: 'Available',
  AVAILABLE_PICKUP_DATES: 'Available pickup dates',
  CONTENTS_AND_ALLERGENS: 'Contents and Allergens',
  SIMILAR_PRODUCTS: 'Similar Products',
  MILK: '🥛 Milk',
  MILK_PROTEIN: '🥛 Milk Protein',
  GLUTEN: '🌾 Gluten',
  NUTS: '🥜 Nuts',
  CRUSTACEANS: '🦞 Crustaceans',
  EGG: '🥚 Egg',
  MOLLUSCS: '🦪 Molluscs',
  FISH: '🐟 Fish',
  PORK: '🥓 Pork',
  PEANUTS: '🥜 Peanuts',
  SESAME_SEEDS: 'Sesame Seeds',
  SULPHUR: 'Sulphur',
  SOYBEANS: '🫘 Soybeans',
  CELERY: '🥬 Celery',
  MUSTARD: 'Mustard',
  LUPIN: 'Lupin',
  GARLIC: '🧄 Garlic',
  MUSHROOM: '🍄‍🟫 Mushroom',
  ALMOND: '🥜 Almond',
  HAZELNUT: '🥜 Hazelnut',
  WALNUT: '🥜 Walnut',
  CASHEW: '🥜 Cashew',
  PECAN: '🥜 Pecan',
  BRAZIL_NUT: '🥜 Brazil Nut',
  PISTACHIO: '🥜 Pistachio',
  MACADAMIA: '🥜 Macadamia',
  DESCRIPTION: 'Description',
  ADDONS: 'Add-ons',
  ADDON_PICK_ONE: 'Pick one',
  ADDON_REQUIRED: 'Required',
  ADDON_OPTIONAL: 'Optional',
  ADDON_MIN: 'Min',
  ADDON_MAX: 'Max',
  ADDON_UNAVAILABLE: 'Unavailable',
  ADDON_SHOW_LESS: 'Show less',
  ADDON_SHOW_FEWER_GROUPS: 'Show fewer groups',
  // Success page translations
  ORDER_CONFIRMED: 'Order Confirmed!',
  ORDER_NUMBER_LABEL: 'Order #',
  PAYMENT_PROCESSED: 'Payment Processed',
  PAYMENT_CONFIRMED: 'Your payment has been confirmed',
  EMAIL_SENT: 'Email Sent',
  EMAIL_CONFIRMATION_SENT: 'Confirmation sent to your inbox',
  ORDER_PROCESSING: 'Order Processing',
  ORDER_PREPARING: 'Restaurant is preparing your order',
  BACK_TO_HOME: 'Back to Home',
  // Failure page translations
  PAYMENT_FAILED: 'Payment Failed',
  PAYMENT_DECLINED: 'Payment Declined',
  PAYMENT_METHOD_DECLINED: 'Your payment method was declined',
  WHAT_TO_DO_NEXT: 'What to do next?',
  VERIFY_PAYMENT_AND_RETRY: 'Verify your payment details and try again',
  HOME: 'Home',
  MAXIMUM_REACHED: 'Maximum reached',
  SEARCH_TEXT: 'Search...',
  IMPORTANT_INFORMATION: 'Important Information',
  DIFFERENT_PRODUCTION_TIMES_WARNING: 'The earliest delivery date is based on the product with the longest production time.',
  GOOGLE_PAY: 'Google Pay',
  GOOGLE_PAY_DESCRIPTION: 'Pay securely with Google Pay',
  APPLE_PAY: 'Apple Pay',
  APPLE_PAY_DESCRIPTION: 'Pay securely with Apple Pay',
  SWISH: 'Swish',
  SWISH_DESCRIPTION: 'Pay securely with Swish',
  COMPLETE_SWISH_PAYMENT: 'Complete Swish Payment',
  SELECT_WHERE_TO_OPEN_SWISH: 'Select where to open Swish',
  LAUNCHES_SWISH_APP: 'Launches Swish app',
  SCAN_QR_CODE: 'Scan QR code',
  CANCEL_PAYMENT: 'Cancel payment',
  // Swish payment component
  SWISH_CHOOSE_HOW_TO_PAY: 'Choose how to pay',
  SWISH_SUBTITLE: 'Use Swish on this device or on another device.',
  SWISH_PAY_ON_THIS_DEVICE: 'Pay on this device',
  SWISH_PAY_ON_OTHER_DEVICE: 'Pay on other device',
  SWISH_SCAN_QR_CODE: 'Scan the QR code with Swish to pay',
  PAYMENT_DEVICE_NOT_SUPPORTED: 'This device does not support Swish Payments',
  SWISH_OPEN_ON_PHONE: 'Open Swish on your phone to pay',
  SWISH_OPEN_APP: 'Open Swish',
  SWISH_PAYMENT_SUCCESS: 'Payment successful',
  SWISH_PAYMENT_FAILED: 'Payment failed',
  SWISH_PAYMENT_ERROR: 'Error while processing payment.',
  SWISH_PAYMENT_CANCELLED_INFO:
    'Payment was cancelled in Swish. Change your order if needed, then use the same Swish button again to get a new QR code.',
  SWISH_VERIFY_TIMEOUT: 'Swish payment timed out',
  BACK_TO_CHECKOUT: 'Back to checkout',
  EARLIEST_DELIVERY_DATE: 'Earliest delivery date',
  EARLIEST_POSSIBLE_DELIVERY_DATE_IS: 'Earliest delivery date is',
  AVAILABLE_FROM: 'Available from',
  DELIVERY_LOCATIONS: 'Delivery locations',
  CORPORATE_DELIVERY_LOCATIONS: 'Delivery locations for this company',
  NO_CORPORATE_CUSTOMERS: 'No corporate customers available',
  COMPANY: 'Company',
  ENTRANCE_CODE: 'Entrance code',
  DEFAULT_REFERENCE: 'Default reference',
  SPECIFIC_LOCATION: 'Specific location',
  SELECT_LOCATION: 'Select location',
  VIEW_ALL_DELIVERY_LOCATIONS: 'View all delivery locations',
  CHANGE: 'Change',
  SELECT: 'Select',
  INVOICE_INFORMATION: 'Invoice information',
  INVOICE_ADDRESS: 'Invoice address',
  ORGANIZATION_NUMBER: 'Organization number',
  VAT_NUMBER: 'VAT number',
  INVOICE_EMAIL: 'Invoice email',
  COST_CENTER: 'Cost center',
  SELECT_DELIVERY_TIME: 'Select delivery time',
  // Login dialog
  LOGIN_TO_YOUR_ACCOUNT: 'Login to Your Account',
  LOGIN_SUBTITLE: 'Log in to manage your catering orders and get access to corporate catering',
  LOGIN_EMAIL_PLACEHOLDER: 'example@email.com',
  PASSWORD: 'Password',
  FORGOT_PASSWORD: 'Forgot password?',
  LOGIN_PASSWORD_PLACEHOLDER: 'Enter your password',
  LOGIN: 'Login',
  CREATE_NEW_ACCOUNT: 'Create new account',
  OR_CONTINUE_WITH: 'Or continue with',
  CONTINUE_WITH_GOOGLE: 'Continue with Google',
  CONTINUE_WITH_MICROSOFT: 'Continue with Microsoft',
  CONTINUE_WITH_APPLE: 'Continue with Apple',
  CREATE_YOUR_ACCOUNT: 'Create Your Account',
  CREATE_ACCOUNT_SUBTITLE: 'Sign up to access company delivery options',
  BACK_TO_LOGIN: 'Back to login',
  CONFIRM_PASSWORD: 'Confirm Password',
  PASSWORD_REQUIREMENTS: 'Password must be at least 6 characters.',
  CREATE_ACCOUNT: 'Create Account',
  OR_SIGN_UP_WITH: 'Or sign up with',
  // Account page
  BACK_TO_STORE: 'Back to store',
  MY_ACCOUNT: 'My Account',
  MY_PAGE: 'My Page',
  ACCOUNT_INFORMATION: 'My details',
  EDIT: 'Edit',
  ADD: 'Add',
  LOGOUT: 'Logout',
  LOGOUT_SUCCESS: 'You have been logged out successfully.',
  ACTIVE_ORDERS: 'Active Orders',
  PREVIOUS_ORDERS: 'Previous Orders',
  ORDER_STATUS: 'Status',
  ORDER_NUMBER: 'Order',
  DECLINED: 'Declined',
  COMPLETED: 'Done',
  DONE: 'Done',
  RECEIPTS: 'Receipts',
  NO_ORDERS_YET: 'No orders yet',
  NO_ACTIVE_ORDERS_YET: 'No active orders',
  NO_ACTIVE_ORDERS_SUBTITLE: "Orders you've placed will appear here while they're being prepared.",
  NO_PREVIOUS_ORDERS_YET: 'No previous orders',
  NO_PREVIOUS_ORDERS_SUBTITLE: 'Completed or declined orders from the last month will show here.',
  NO_RECEIPTS_YET: 'No receipts yet',
  NO_RECEIPTS_SUBTITLE: 'Receipts for your orders will appear here.',
  NO_CORPORATE_COMPANY_CONNECTED: 'No company connected',
  NO_CORPORATE_COMPANY_SUBTITLE: 'Connect to a company account to order for delivery to your workplace.',
  WANT_DELIVERY_TO_YOUR_COMPANY: 'Want delivery to your company?',
  DELIVERY_TO_COMPANY: 'Corporate delivery',
  DELIVERY_NOT_AVAILABLE_NO_COMPANY: 'Delivery not available',
  DELIVERY_NOT_AVAILABLE_NO_COMPANY_DESCRIPTION: 'You are not eligible to corporate catering',
  NO_SERVING_METHODS_AVAILABLE: 'No serving methods available',
  NO_SERVING_METHODS_AVAILABLE_DESCRIPTION: 'This restaurant is currently not accepting pickup or delivery orders.',
  CREATE_ACCOUNT_OR_LOGIN: 'Login or create account',
  ENTER_PHONE: 'Enter phone',
  CURRENT_PASSWORD: 'Current Password',
  ENTER_CURRENT_PASSWORD: 'Enter current password',
  SAVE: 'Save',
  // Account receipts
  CLIENT_INFORMATION: 'Client Information',
  VAT_ID: 'VAT ID',
  RECEIPT: 'Receipt',
  RECEIPT_NUMBER: 'Receipt Number',
  DATE: 'Date',
  PRODUCTS: 'Products',
  PRODUCT: 'Product',
  DISCOUNT: 'Discount',
  // Forgot password page
  FORGOT_PASSWORD_TITLE: 'Forgot your password?',
  FORGOT_PASSWORD_SUBTITLE: 'Enter your email address to receive a password reset link.',
  FORGOT_PASSWORD_EMAIL_PLACEHOLDER: 'Enter your email address',
  FORGOT_PASSWORD_SUBMIT: 'Send reset link',
  FORGOT_PASSWORD_BACK: 'Back to login',
  FORGOT_PASSWORD_EMAIL_SENT: 'A password reset link has been sent to your email.',
  FORGOT_PASSWORD_FAILED: 'Failed to send reset email. Please try again.',
  FORGOT_PASSWORD_INVALID_EMAIL: 'Please enter a valid email address.',
  GO_BACK: 'Go back',
  SUBMIT: 'Submit',

  //Home-panel translations
  CATEGORIES: 'Categories',
  DIETARY_OPTIONS: 'Dietary options',
  SAVED_CARDS: 'Saved Cards',
  COMING_SOON: 'Coming soon',
  ORDERS: 'Orders',
  SHOW_MORE: 'Show more',
  SHOW_LESS: 'Show less',
  APPLY_FILTER: 'Apply filter',
  START_DATE: 'Start date',
  END_DATE: 'End date',
  FILTER_RESULT: 'Filter result',
  TOTAL_ACTIVE_ORDERS: 'Total Active Orders',
  TOTAL_PREVIOUS_ORDERS: 'Total Previous Orders',
  TOTAL_SAVED_RECEIPTS: 'Total Saved Receipts',
  CARD_DETAILS: 'Card Details',
  ALL: 'All',
  CARD: 'Card',
  REMOVE_CARD: 'Remove Card',
  REMOVE_CARD_TITLE: 'Remove Saved Card?',
  REMOVE_CARD_WARNING: 'This card will be permanently removed from all PubQ systems — including the mobile app, web ordering, and all other PubQ platforms. This action cannot be undone.',
  REMOVE_CARD_CONFIRM: 'Yes, Remove Card',
  REMOVE_CARD_FAILED: 'Failed to remove card. Please try again.',
  REMOVING_CARD: 'Removing…',
  SELECT_BOTH_START_END_DATES: 'Select both start and end dates.',
  START_DATE_MUST_BE_BEFORE_END_DATE: 'Start date must be before end date.',
  CATERING_PENDING: 'Pending',
  APPROVED: 'Approved',
  COUPON: 'Discounts',
  APPLY_DISCOUNT: 'Apply discount',
  COUPON_CODE: 'Discount code',
  HAVE_A_COUPON_CODE: 'Have a discount code?',
  USE_COUPON_CODE: 'Use your discount code',
  ENTER_YOUR_CODE_BELOW: 'Enter your code below',
  ENTER_YOUR_CODE_HERE: 'Enter your code',
  APPLY: 'Apply',
  REMOVE: 'Remove',
  TOTAL_DISCOUNT: 'Total Discount',
  INVALID_COUPON: 'Invalid code',
  CHECKING_DISCOUNT_CODE: 'Checking code…',
  APPLIED_DISCOUNT: 'Applied discount',
  UNEXPECTED_ERROR: 'An unexpected error occurred.',
  UNEXPECTED_ERROR_TRY_AGAIN: 'An unexpected error occurred. Please try again.',
  PLEASE_FILL_REQUIRED_FIELDS: 'Please fill in all required fields',
  EACH: 'each',
  TOTAL_ITEMS_PRODUCT_PAGE: 'Items',
  ONLY_ONE_SERVING_METHOD_AVAILABLE: 'Date selection',
  SELECT_WEEKDAY_SINGLE_METHOD: 'When would you like to receive your order?',
  POWERED_BY: 'Powered by',
  FROM: 'From',
  EX_VAT: 'excl. VAT',
  OF_WHICH_VAT: 'of which VAT',
  VAT_AMOUNT: 'VAT',
  TOTAL_INC_VAT: 'Total incl. VAT',
  NO_COST: 'No cost',

  // --- Guest "order by invoice" checkout (no login) ---
  GUEST_INVOICE_TITLE: "Order by invoice",
  DELIVERY_GUEST_INVOICE: "Delivery / order by invoice",
  GUEST_INVOICE_DESCRIPTION: "No account needed — we invoice your company",
  GUEST_INVOICE_EVENT_SECTION: "Event details",
  GUEST_INVOICE_EVENT_SECTION_DESCRIPTION: "Tell us about the meeting the catering is for.",
  GUEST_INVOICE_BILLING_SECTION: "Company and invoicing details",
  GUEST_INVOICE_BILLING_SECTION_DESCRIPTION: "The invoice is sent to these details. No payment is taken now.",
  MEETING_ROOM_NAME: "Meeting room name",
  MEETING_ROOM_NAME_PLACEHOLDER: "e.g. Meeting room Aurora",
  NUMBER_OF_ATTENDEES: "Number of attendees",
  EVENT_HOST: "Event host",
  EVENT_END_TIME: "Event ends (optional)",
  SPECIAL_DIETS: "Special diets",
  SPECIAL_DIETS_PLACEHOLDER: "e.g. 2 gluten-free, 1 vegan",
  PARTICIPANT_LIST: "Participant list",
  PARTICIPANT_LIST_PLACEHOLDER: "Names of the participants (optional)",
  INVOICE_REFERENCE: "Invoice reference",
  INVOICE_REFERENCE_PLACEHOLDER: "e.g. project or reference number",
  INVOICE_NO_PAYMENT_TAKEN: "No payment taken",
  INVOICE_WILL_FOLLOW: "Nothing has been charged. An invoice will be sent to the billing details you provided.",
  ORDER_TERMS_TITLE: "Order terms",
  ORDER_TERMS_BODY: "The order is binding. Changes and cancellations must be made no later than two (2) working days before the event; later cancellations are invoiced in full. The number of attendees confirmed at ordering is the basis for invoicing. Payment term 14 days net.",

  // --- Partner group restaurant picker (/g/:slug) ---
  PARTNER_CHOOSE_RESTAURANT: "Choose a restaurant",
  PARTNER_CHOOSE_RESTAURANT_HINT: "Pick where you would like to order your catering from.",
  PARTNER_ORDER_FROM_HERE: "Order",
  PARTNER_GROUP_NOT_FOUND: "Page not found",
  PARTNER_GROUP_NOT_FOUND_DESCRIPTION: "This restaurant group link is not available. Please check the link and try again.",
};
